export default __webpack_public_path__ + "static/media/red.99245ec6.webp";